export default __webpack_public_path__ + "audio/1d052b84cce8c117346cfa604c5b91fb-tankStrike.wav";